import { CustomerAddress } from '../../Address/Address';
import { Link } from '../../Link/Link';
import { Image } from '../../Media/Media';
import { PriceBaseInterface, ProductPriceInterface } from '../../Price/Price';

export const cartToken = 'cartToken';

export interface CartItem {
    id: string;
    variantId?: string;
    variantCode: string;
    legacyId?: string;
    productCode?: string;
    name: string;
    relativeUrl: string;
    quantity: number;
    image?: Image;
    brand?: Link;
    categories?: string[];
    stock: number;
    price: ProductPriceInterface;
}

export interface CartInterface extends PriceBaseInterface {
    id: string;
    loods5Id?: string;
    items: CartItem[];
    addresses?: CustomerAddress[];
    orderedAt?: string;
}
